module.exports = __webpack_public_path__ + "img/isPro4_2.c6e1da48.png";